import Lookup from './lookup.js';

export default class LevelTwo extends Lookup
{
    
}
